/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  export class MeevoObjectStateSwitch implements angular.IDirective {
    restrict = "E";
    require = "ngModel";
    scope = {
        ngModel: "=ngModel",
        contentKey: "@",
        switchOnKey: "@",
        switchOffKey: "@",
        trinaryKey: "@",
        disabled: "=ngDisabled",
        ngChange: "&",
        switchOnState: "=?",
        switchOffState: "=?",
        trinaryState: "=?",
        ariaLabel: "@",
        color: '=?',
        tabIndex: '=?'
    };

    //template = "<div ng-show=\"!isDeleted\" class=\"meevo-input-wrapper\"><label class=\"meevo-switch-label\" translate=\"{{::contentKey}}\"></label><md-switch ng-model=\"ngModel\" ng-true-value=\"{{activeValue}}\" ng-false-value=\"{{inactiveValue}}\" ng-disabled=\"disabled\"></md-switch>" +
    //"</div>" +
    //"<div ng-show=\"isDeleted\">DELETED</div>";
   
    templateUrl = 'app/components/controls/objectStateSwitchTemplate.html';

    compile = (element: angular.IAugmentedJQuery, attrs: angular.IAttributes, transclude: angular.ITranscludeFunction) => {
      
      return {
        pre: (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
          // initialize keys
          scope.switchOnKey = this.$translate.instant(Model.Guard.isNothing(scope.switchOnKey) ? "LABEL_ACTIVE" : scope.switchOnKey);
          scope.switchOffKey = this.$translate.instant(Model.Guard.isNothing(scope.switchOffKey) ? "LABEL_INACTIVE" : scope.switchOffKey);
          scope.trinaryKey = this.$translate.instant(Model.Guard.isNothing(scope.trinaryKey) ? "LABEL_DELETED" : scope.trinaryKey);
          // initialize values
          scope.switchOnState = Model.Guard.isNothing(scope.switchOnState, false) ? Meevo.Model.ObjectStateEnum.Active : scope.switchOnState;
          scope.switchOffState = Model.Guard.isNothing(scope.switchOffState, false) ? Meevo.Model.ObjectStateEnum.Inactive : scope.switchOffState;
          scope.trinaryState = Model.Guard.isNothing(scope.trinaryState, false) ? Meevo.Model.ObjectStateEnum.Deleted : scope.trinaryState;
          // set values
          scope.activeValue = scope.switchOnState;
          scope.inactiveValue = scope.switchOffState;
          scope.trinaryState = scope.trinaryState;

          if (typeof scope.color === 'undefined') {
            scope.color = '#512DA8';
          }

          scope.$watch("ngModel", () => {
            scope.updateContentKey();
          });
         
          if (scope.tabIndex){
              scope.$watch(
                  function () {
                      var mdSwitchElem: any = element.find('md-switch');
                      mdSwitchElem = mdSwitchElem.attr('tabIndex');
                      return mdSwitchElem;
                  },
                  function (newVal, oldVal) {
                      if (newVal == oldVal || newVal == -1) { return }
                      var mdSwitchElem: any = element.find('md-switch');
                      mdSwitchElem.attr('tabIndex', scope.tabIndex);
                  }
              );
          }
          


          scope.updateContentKey = (): void => {
            switch (scope.ngModel) {
              case scope.trinaryState:
                scope.contentKey = scope.trinaryKey;
                break;
              case scope.switchOffState:
                scope.contentKey = scope.switchOffKey;
                break;
              default:
                scope.contentKey = scope.switchOnKey;
                break;
            }
            // update layout
            scope.isDeleted = scope.ngModel === scope.trinaryState;
          }

          scope.updateContentKey();
        },
        post: (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
          
        }
      }
    }

    constructor(private $translate: angular.translate.ITranslateService) {
    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($translate) => {
        return new MeevoObjectStateSwitch($translate);
      };
      directive.$inject = ["$translate"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoObjectStateSwitch", MeevoObjectStateSwitch.factory());
}